import * as _ from 'lodash';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import { Store } from 'react-redux';
import { StoreState } from '../store';
import { newError } from '../actions';
import { ErrorResponse } from '../api/model';

const strings = {
    error401: 'Your session has expired, you will be logged out',
    error403: 'You are not authorized to access this resource',
    error404: 'Specified resource does not exist',
    error5xx: 'Something went wrong, please try again later',
    errorNetwork: 'No Internet connection',
    errorTimeout: 'Please try again.'
};

const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 30_000
});

export const configureClient = (store: Store<StoreState>) => {
    client.interceptors.request.use(
        (config: AxiosRequestConfig) => {
            const state = store.getState();
            if (state.auth) {
                const { token } = state.auth;
                // tslint:disable-next-line
                config.headers['Authorization'] = 'Bearer ' + token;
            }

            config.headers['Cache-Control'] = 'no-cache';

            return config;
        },
        error => {
            return Promise.reject(error);
        }
    );

    client.interceptors.response.use(response => response, (error: AxiosError) => {
        let reason: ErrorResponse | null = null;

        if (error.config != null) {
            return Promise.reject(reason);
        }

        if (error.message === 'Network Error') {
            store.dispatch(newError(strings.errorNetwork, '500'));
        } else if (_.startsWith(error.message, 'timeout')) {
            store.dispatch(newError(strings.errorTimeout, '500'));
        } else if (error.response) {
            const { status } = error.response;

            if (status === 400) {
                reason = { error: 400 };
            } else if (status === 401) {
                store.dispatch(newError(strings.error401, '401'));
            } else if (status === 403) {
                store.dispatch(newError(strings.error403, '403'));
            } else if (status === 404) {
                store.dispatch(newError(strings.error404, '404'));
            } else if (status >= 500) {
                store.dispatch(newError(strings.error5xx, '500'));
            }
        }

        return Promise.reject(reason);
    });
};

export default client;



// WEBPACK FOOTER //
// ./src/api/client.ts